import { computed, makeObservable } from 'mobx'

import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

export interface IGender {
  id: number
  name: string
}

class Gender extends Model<IGender> {
  static urlRoot() {
    return '/genders'
  }

  constructor(attr: IGender) {
    super(attr)

    makeObservable(this, {
      name: computed,
      formattedName: computed,
    })
  }

  get name(): string {
    return this.attributes.name
  }

  get formattedName(): string {
    const name = this.name
    switch (name) {
      case 'male':
        return i18n.t('common.male')
      case 'female':
        return i18n.t('common.female')
      default:
        return this.name
    }
  }
}

export default Gender
